/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 190:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(191);
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(132);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(135);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(177);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(193);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(123);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(195);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(148);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(142);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(146);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(147);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(124);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(138);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(2);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(196);
var _window$Shopify, _window$Shopify$theme, _window$Shopify$theme2;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }






















var sectionType = 'header';
var registeredSections = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : (_window$Shopify$theme = _window$Shopify.theme) === null || _window$Shopify$theme === void 0 ? void 0 : (_window$Shopify$theme2 = _window$Shopify$theme.sections) === null || _window$Shopify$theme2 === void 0 ? void 0 : _window$Shopify$theme2.registered) || {};
var isUnregistered = typeof registeredSections[sectionType] === 'undefined';
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isUnregistered && (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_19__.register)(sectionType, {
  onLoad: function onLoad() {
    var _this = this;

    var self = this;
    var isSticky = this.container.dataset.isSticky;
    this.isSticky = isSticky === 'true';
    var btnMenuOpen = this.container.querySelector('.nav-toggle');

    if (btnMenuOpen) {
      btnMenuOpen.addEventListener('click', this.btnMenuClickOpenHandler.bind(this));
    }

    var btnMenuClose = this.container.querySelector('.nav-close');

    if (btnMenuClose) {
      btnMenuClose.addEventListener('click', this.btnMenuClickCloseHandler.bind(this));
    }

    var desktopQuery = window.matchMedia("(min-width: ".concat(window.theme.breakpoints.header, "px)"));

    var desktopQueryCallback = function desktopQueryCallback(evt) {
      _this.handleResize();

      if (evt.matches) {
        _this.calculateNavDropdownMaxSize();
      }
    }; // Check for `addEventListener` is required to support iOS and Safari <14.


    if (typeof (desktopQuery === null || desktopQuery === void 0 ? void 0 : desktopQuery.addEventListener) === 'function') {
      desktopQuery.addEventListener('change', desktopQueryCallback.bind(this));
    } else {
      desktopQuery.addListener(desktopQueryCallback.bind(this));
    }

    if (desktopQuery.matches) {
      this.calculateNavDropdownMaxSize();
    }

    var navOverlay = this.container.querySelector('.fader--nav');
    navOverlay === null || navOverlay === void 0 ? void 0 : navOverlay.addEventListener('click', this.btnMenuClickCloseHandler.bind(this));
    var desktopTopLevelNavToggles = this.container.querySelectorAll('.nav__item--toggle');
    desktopTopLevelNavToggles.forEach(function (el) {
      return el.addEventListener('click', self.navLinkClickHandler.bind(self));
    });
    var mobileTopLevelNavToggles = this.container.querySelectorAll('.mobile-nav__item--toggle.top-level');
    mobileTopLevelNavToggles.forEach(function (el) {
      return el.addEventListener('click', self.showMobileSubMenu.bind(self));
    });

    // Mobile drawer: hide nav as soon as search has a query. /* BBB-111 mobile search hide */
    // Lives here (not app.js) because the webpack app chunk has a fixed filename
    // with no ?v= bust and browsers keep serving a stale bundle.
    this._onMobileSearchInput = function (event) {
      var input = event.target;
      if (!input || !input.classList || !input.classList.contains('search__input')) return;
      var host = document.getElementById('react-search-modal--mobile');
      if (!host || !host.contains(input)) return;
      var hasQuery = Boolean((input.value || '').trim());
      host.classList.toggle('is-searching', hasQuery);
      document.body.classList.toggle('mobile-search-is-active', hasQuery);
      var drawer = document.querySelector('.drawer--left');
      if (drawer) {
        drawer.classList.toggle('drawer--search-active', hasQuery);
      }
    };
    document.addEventListener('input', this._onMobileSearchInput, true);
    var megamenuParentItems = this.container.querySelectorAll('.parent-menu__nav-toggle');
    megamenuParentItems.forEach(function (el) {
      return el.addEventListener('click', self.showMegamenuSubMenu.bind(self));
    });
    var megamenuChildItems = this.container.querySelectorAll('.child-menu__nav-toggle');
    megamenuChildItems.forEach(function (el) {
      return el.addEventListener('click', self.showMegamenuSubMenu.bind(self));
    });
    var mobileMenuBackButtons = this.container.querySelectorAll('.mobile-menu__back');
    mobileMenuBackButtons.forEach(function (el) {
      return el.addEventListener('click', self.mobileMegamenuBack.bind(self));
    }); // Set the header height as a css variable that we can use in our stylesheet to offset the header

    var debouncedSetHeaderOffsetHeight = (0,_utils_debounce__WEBPACK_IMPORTED_MODULE_20__.debounce)(function (event) {
      _this.setHeaderOffsetHeight(event);
    }, 250);
    window.addEventListener('resize', debouncedSetHeaderOffsetHeight);
    this.setHeaderOffsetHeight(); // Update header if over homepage image section

    if (document.body.classList.contains('template-index') && window.theme.header.lightOverlayOnHomepage) {
      this.toggleHeaderStateOnHomepage();
    }
  },
  toggleHeaderStateOnHomepage: function toggleHeaderStateOnHomepage() {
    var header = document.querySelector('.header');
    var main = document.querySelector('main');
    var firstSection = main.firstElementChild;
    var intersectionObserver = new IntersectionObserver(function (entries) {
      if (entries[0].intersectionRatio <= 0) {
        header.classList.remove('header--light');
      } else {
        header.classList.add('header--light');
      }
    });
    intersectionObserver.observe(firstSection);
  },
  setHeaderOffsetHeight: function setHeaderOffsetHeight() {
    var headerOffset = this.isSticky ? "".concat(this.container.offsetHeight, "px") : '0';
    document.documentElement.style.setProperty('--header-offset', headerOffset);
  },
  calculateNavDropdownMaxSize: function calculateNavDropdownMaxSize() {
    var header = this.container;

    var getMegamenuColumnCount = function getMegamenuColumnCount(dropdown) {
      var parentMenu = dropdown.querySelector('.desktop-menu .parent-menu');
      if (!parentMenu) return 0;
      var count = 0;
      parentMenu.querySelectorAll(':scope > .parent_column').forEach(function (col) {
        var customColumns = col.querySelectorAll('.custom_column');
        if (customColumns.length) {
          count += customColumns.length;
          return;
        }
        var childrenColumn = col.querySelector('.children-column__nav-item');
        if (childrenColumn) {
          var styleColumns = parseInt(childrenColumn.style.columns || childrenColumn.style.columnCount, 10);
          if (!styleColumns) {
            styleColumns = parseInt(window.getComputedStyle(childrenColumn).columnCount, 10);
          }
          count += styleColumns && styleColumns > 0 ? styleColumns : 1;
          return;
        }
        count += 1;
      });
      return count;
    };

    var positionNavDropdowns = function positionNavDropdowns() {
      var headerContainer = header.querySelector('.header-container') || header;
      var containerRect = headerContainer.getBoundingClientRect();
      var parentItems = header.querySelectorAll('.header__grid-left--desktop .header-item');
      parentItems.forEach(function (parentItem) {
        var dropdown = parentItem.querySelector('.nav__dropdown');
        if (!dropdown) return;
        dropdown.style.right = 'auto';
        dropdown.style.marginLeft = '0';
        dropdown.style.marginRight = '0';
        var columnCount = getMegamenuColumnCount(dropdown);
        var left;
        if (columnCount >= 4) {
          var dropdownWidth = dropdown.offsetWidth;
          left = Math.max(0, Math.round((containerRect.width - dropdownWidth) / 2));
        } else {
          left = Math.round(parentItem.getBoundingClientRect().left - containerRect.left);
        }
        dropdown.style.left = "".concat(left, "px");
      });
      var headerSize = header.getBoundingClientRect();
      var navDropdownMaxHeight = Math.floor(window.innerHeight - headerSize.height);
      var navDropdowns = header.querySelectorAll('.nav__dropdown');
      navDropdowns.forEach(function (el) {
        if (el && window.innerWidth > window.theme.breakpoints.header) {
          el.style.maxHeight = "".concat(navDropdownMaxHeight, "px");
        } else {
          el.style.left = '';
          el.style.right = '';
          el.style.marginLeft = '';
          el.style.marginRight = '';
          el.style.maxHeight = '';
        }
      });
    };

    this.positionNavDropdowns = positionNavDropdowns;
    window.addEventListener('load', positionNavDropdowns);
    window.addEventListener('resize', positionNavDropdowns);
  },
  handleResize: function handleResize() {
    this.btnMenuClickCloseHandler();
    this.collapseDropdown();
  },

  /**
   * Click handler for dropdowns
   */
  collapseDropdown: function collapseDropdown() {
    var activeDropdownLinks = this.container.querySelectorAll('.nav__item.nav__item--has-child.is-expanded');
    var navToggles = this.container.querySelectorAll('.nav__item.nav__item--has-child.is-expanded .nav__item--toggle');
    document.body.classList.remove('dropdown-is-active');
    activeDropdownLinks.forEach(function (el) {
      el.classList.remove('is-expanded');
      el.classList.add('is-collapsed');
    });
    navToggles.forEach(function (el) {
      return el.setAttribute('aria-expanded', false);
    });
  },

  /**
   * .nav-toggle click handler
   */
  btnMenuClickOpenHandler: function btnMenuClickOpenHandler() {
    document.body.classList.add('menu-is-expanded');
    var subMenuParentsExpanded = this.container.querySelectorAll('.nav__item--has-child.is-expanded');
    subMenuParentsExpanded.forEach(function (el) {
      el.classList.remove('is-expanded');
      setTimeout(function () {
        return el.classList.add('is-collapsed');
      }, 200);
    });
  },
  btnMenuClickCloseHandler: function btnMenuClickCloseHandler() {
    document.body.classList.remove('menu-is-expanded');
    document.body.classList.remove('dropdown-is-active');
    document.body.classList.remove('mobile-search-is-active');
    var mobileSearchHost = document.getElementById('react-search-modal--mobile');
    if (mobileSearchHost) {
      mobileSearchHost.classList.remove('is-searching');
    }
    var drawer = document.querySelector('.drawer--left');
    if (drawer) {
      drawer.classList.remove('drawer--search-active');
    }
    var subMenuParents = this.container.querySelectorAll('.nav__item--has-child.is-expanded');
    subMenuParents.forEach(function (el) {
      el.classList.remove('is-expanded');
      el.classList.add('is-collapsed');
    });
  },
  isDescendant: function isDescendant(parent, child) {
    var node = child.parentNode;

    while (node != null) {
      if (node === parent) {
        return true;
      }

      node = node.parentNode;
    }

    return false;
  },

  /**
   * Megamenu dropdown toggle
   */
  navLinkClickHandler: function navLinkClickHandler(event) {
    if (this.isDescendant(document.querySelector('.megamenu'), event.target) || event.target.classList.contains("megamenu-link") || event.target.classList.contains("nav-link") || event.target.classList.contains("parent-menu__nav-item") || event.target.classList.contains("parent_column") || event.target.classList.contains("nav__dropdown") || event.target.classList.contains("megamenu__menu-conceal")) return;
    var navOverlay = document.querySelector('.fader--nav');
    navOverlay === null || navOverlay === void 0 ? void 0 : navOverlay.addEventListener('click', this.btnMenuClickCloseHandler.bind(this));
    event.preventDefault();
    var desktopQuery = window.matchMedia("(min-width: ".concat(window.theme.breakpoints.header, "px)"));
    var navLinks = this.container.querySelectorAll('.nav__item--toggle');
    var thisNavItem = event.currentTarget;
    var childMenus = thisNavItem.querySelectorAll('.child-menu');
    var grandchildMenus = thisNavItem.querySelectorAll('.grandchild-menu');
    childMenus.forEach(function (menu) {
      menu.classList.remove('active');
    });
    grandchildMenus.forEach(function (menu) {
      menu.classList.remove('active');
    });

    if (thisNavItem.classList.contains('is-expanded')) {
      thisNavItem.setAttribute('aria-expanded', false);
      thisNavItem.classList.remove('is-expanded');
      setTimeout(function () {
        return thisNavItem.classList.add('is-collapsed');
      }, 200);
      document.body.classList.remove('dropdown-is-active');
    } else {
      document.body.classList.add('dropdown-is-active');
      navLinks.forEach(function (el) {
        return el.classList.remove('is-expanded');
      });
      navLinks.forEach(function (el) {
        return el.classList.add('is-collapsed');
      });
      navLinks.forEach(function (el) {
        return el.setAttribute('aria-expanded', false);
      });
      thisNavItem.classList.remove('is-collapsed');
      thisNavItem.classList.add('is-expanded');
      thisNavItem.setAttribute('aria-expanded', true);

      if (desktopQuery.matches) {
        if (typeof this.positionNavDropdowns === 'function') {
          this.positionNavDropdowns();
        }
        this.initializeMegamenu(thisNavItem);
      }
    }

    return true;
  },

  /**
   * Set initial height of megamenu
   */
  initializeMegamenu: function initializeMegamenu(navItem) {
    var navDropdown = navItem.querySelector('.nav__dropdown');
    var navDropdownHeight = navDropdown.clientHeight;
    var parentMenuHeight = navDropdown.querySelector('.parent-menu').clientHeight;
    var megamenuTopPadding = parseInt(window.getComputedStyle(navDropdown, null).getPropertyValue('padding-top').replace('px', ''), 10);
    var megamenuBottomPadding = parseInt(window.getComputedStyle(navDropdown, null).getPropertyValue('padding-bottom').replace('px', ''), 10);
    var combinedHeight = megamenuTopPadding + megamenuBottomPadding + parentMenuHeight;

    if (combinedHeight > navDropdownHeight) {
      navDropdown.style.height = "".concat(combinedHeight, "px");
    }
  },

  /**
   * Resize megamenu on each submenu opening
   */
  resizeMegamenu: function resizeMegamenu() {
    var navDropdown = this.container.querySelector('.nav__dropdown');
    var megamenuTopPadding = parseInt(window.getComputedStyle(navDropdown, null).getPropertyValue('padding-top').replace('px', ''), 10);
    var megamenuBottomPadding = parseInt(window.getComputedStyle(navDropdown, null).getPropertyValue('padding-bottom').replace('px', ''), 10);
    var allActiveSubmenus = Array.from(this.container.querySelectorAll('.submenu.active'));
    allActiveSubmenus.push(this.container.querySelector('.parent-menu'));
    var menuHeights = allActiveSubmenus.map(function (menu) {
      return menu.clientHeight;
    });
    var heighestActiveMenu = Math.max.apply(Math, _toConsumableArray(menuHeights));
    var combinedHeight = megamenuTopPadding + megamenuBottomPadding + heighestActiveMenu;
    navDropdown.style.height = "".concat(combinedHeight, "px");
  },

  /**
   * Open megamenu submenus ( parent, child & grandchild)
   */
  showMegamenuSubMenu: function showMegamenuSubMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    var desktopQuery = window.matchMedia("(min-width: ".concat(window.theme.breakpoints.header, "px)"));
    var thisMegamenu = event.target.closest('.nav__dropdown');
    var elementIsParent = event.target.classList.contains('parent-menu__nav-item');
    var thisTitle = event.target.dataset.title;
    var childMenus = thisMegamenu.querySelectorAll('.child-menu');
    var grandchildMenus = thisMegamenu.querySelectorAll('.grandchild-menu');
    var parentMenuItems = thisMegamenu.querySelectorAll('.parent-menu__nav-item');
    var childMenuItems = thisMegamenu.querySelectorAll('.child-menu__nav-item');
    var nestedMenus = elementIsParent ? childMenus : grandchildMenus;
    var siblingMenuItems = elementIsParent ? parentMenuItems : childMenuItems;
    childMenuItems.forEach(function (menu) {
      menu.classList.add('active');
    });
    grandchildMenus.forEach(function (menu) {
      menu.classList.remove('active');
    });
    siblingMenuItems.forEach(function (siblingMenuItem) {
      siblingMenuItem.classList.remove('active');
    });
    event.target.classList.add('active');
    nestedMenus.forEach(function (menu) {
      menu.classList.remove('active');

      if (menu.dataset.parentLink === thisTitle) {
        menu.classList.add('active');
      }
    });

    if (desktopQuery.matches) {
      this.resizeMegamenu();
    }
  },

  /**
   * Open mobile submenus
   */
  showMobileSubMenu: function showMobileSubMenu(event) {
    event.stopPropagation();
    if (event.target.href) return;
    if (event.target && !event.target.classList.contains('mobile-nav__item--toggle') && !e.target.classList.contains("mobile-nav__item--toggle") && !e.target.classList.contains("icon-chevron-right") && !e.target.classList.contains("nav-toggle__title") && !e.target.classList.contains("parent-menu__nav-toggle")) return;
    var topLevelNavLinks = this.container.querySelectorAll('.mobile-nav__item--toggle');
    var thisNavItem = event.currentTarget;

    if (thisNavItem.classList.contains('is-expanded')) {
      thisNavItem.setAttribute('aria-expanded', false);
      thisNavItem.classList.remove('is-expanded');
      setTimeout(function () {
        return thisNavItem.classList.add('is-collapsed');
      }, 200);
    } else {
      topLevelNavLinks.forEach(function (el) {
        return el.classList.remove('is-expanded');
      });
      topLevelNavLinks.forEach(function (el) {
        return el.classList.add('is-collapsed');
      });
      topLevelNavLinks.forEach(function (el) {
        return el.setAttribute('aria-expanded', false);
      });
      thisNavItem.classList.remove('is-collapsed');
      thisNavItem.classList.add('is-expanded');
      thisNavItem.setAttribute('aria-expanded', true);
    }

    return true;
  },

  /**
   * Mobile menu back one level
   */
  mobileMegamenuBack: function mobileMegamenuBack(event) {
    event.stopPropagation();
    var isParentLevel = event.target.classList.contains('mobile-menu__back--parent-level');
    var isChildOrGrandchildLevel = event.target.classList.contains('mobile-menu__back--child-level') || event.target.classList.contains('mobile-menu__back--grandchild-level');

    if (isParentLevel) {
      var topLevelNavItem = event.target.closest('.is-expanded');
      topLevelNavItem.setAttribute('aria-expanded', false);
      topLevelNavItem.classList.remove('is-expanded');
      setTimeout(function () {
        return topLevelNavItem.classList.add('is-collapsed');
      }, 200);
    }

    if (isChildOrGrandchildLevel) {
      event.target.parentNode.classList.remove('active');
    }
  }
}));

/***/ }),

/***/ 196:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "debounce": () => (/* binding */ debounce)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(177);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__);

var debounce = function debounce(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      timeoutId = null;
      callback.apply(void 0, args);
    }, delay);
  };
};

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			14: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkbibendum"] = self["webpackChunkbibendum"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [37], () => (__webpack_require__(190)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;
